import { render, staticRenderFns } from "./BriqEnvironment.vue?vue&type=template&id=5463de00&scoped=true&lang=pug&"
import script from "./BriqEnvironment.vue?vue&type=script&lang=js&"
export * from "./BriqEnvironment.vue?vue&type=script&lang=js&"
import style0 from "./BriqEnvironment.vue?vue&type=style&index=0&id=5463de00&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5463de00",
  null
  
)

export default component.exports